import { render, staticRenderFns } from "./CompanyDeputySecretary.vue?vue&type=template&id=1a027f3b&scoped=true&"
import script from "./CompanyDeputySecretary.vue?vue&type=script&lang=js&"
export * from "./CompanyDeputySecretary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a027f3b",
  null
  
)

export default component.exports